import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {SessionManager} from "../../session-manager";

export class PublicRoute extends React.Component {

    render() {
        return !SessionManager.isAuthenticated() ? <Route {...this.props} /> :
            <Redirect to={{pathname: "/", state: {}}}/>
    }
}